export default (validationState) => {
  for(let v of Object.keys(validationState)){
    const [state, setState] = validationState[v];
    if(state){
      setState(false);
    }
  }
}
